import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';

import { DocumentContainerDetails } from '../models/document.model';

import { catchError, delay, map, tap } from 'rxjs/operators';
import { DocumentsService } from '../services/sections/documents/documents.service';
import { GlobalSettingsService } from '../services/ui/global-settings.service';

@Injectable({
	providedIn: 'root'
})
export class DocumentContainerResolver implements Resolve<DocumentContainerDetails> {
	constructor(
		private router: Router,
		private documentService: DocumentsService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.documentService
			.getDocumentContainerDetails(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				tap(() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
				})
			);
	}
}
